<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Appearance') }}</h1>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                    <router-link
                        class="btn btn-blue shadow-sm rounded-md"
                        to="/dashboard/admin/settings"
                    >
                        {{ $t('Back') }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6">
                <loading :status="loading"/>
                <form @submit.prevent="save">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white sm:p-6">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="app_icon">{{ $t('Icon') }}</label>
                                    <image-input id="app_icon" v-model="app_icon" :remove="false"></image-input>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="app_background">{{ $t('Background') }}</label>
                                    <image-input id="app_background" v-model="app_background" :remove="false"></image-input>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="background_video_mp4">{{ $t('Background Video (MP4)') }}</label>
                                    <video-input id="background_video_mp4" v-model="background_video_mp4" accept="video/mp4"></video-input>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="background_video_webm">{{ $t('Background Video (WebM)') }}</label>
                                    <video-input id="background_video_webm" v-model="background_video_webm" accept="video/webm"></video-input>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="background_video_url">{{ $t('Background Video URL') }}</label>
                                    <input
                                        id="background_video_url"
                                        v-model="background_video_url"
                                        type="url"
                                        :placeholder="$t('Or enter external video URL')"
                                        class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                                    />
                                </div>
                                <div class="col-span-3 mt-6 border-t pt-6">
                                    <h3 class="text-lg font-medium text-gray-900 mb-4">{{ $t('Login Page Text') }}</h3>
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium leading-5 text-gray-700" for="login_welcome_title">{{ $t('Welcome Title') }}</label>
                                        <input
                                            id="login_welcome_title"
                                            v-model="login_welcome_title"
                                            type="text"
                                            :placeholder="$t('e.g., Selamat Datang!')"
                                            class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                                        />
                                    </div>
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium leading-5 text-gray-700" for="login_welcome_subtitle">{{ $t('Welcome Subtitle') }}</label>
                                        <input
                                            id="login_welcome_subtitle"
                                            v-model="login_welcome_subtitle"
                                            type="text"
                                            :placeholder="$t('e.g., Enter your information to log in')"
                                            class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                                        />
                                    </div>
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium leading-5 text-gray-700" for="login_button_text">{{ $t('Login Button Text') }}</label>
                                        <input
                                            id="login_button_text"
                                            v-model="login_button_text"
                                            type="text"
                                            :placeholder="$t('e.g., Masuk')"
                                            class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 py-3 bg-gray-100 text-right sm:px-6">
                            <div class="inline-flex">
                                <button class="btn btn-green rounded-md shadow-sm" type="submit">
                                    {{ $t('Save settings') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "appearance",
    data() {
        return {
            loading: true,
            app_icon: null,
            app_background: null,
            background_video_mp4: null,
            background_video_webm: null,
            background_video_url: '',
            login_welcome_title: '',
            login_welcome_subtitle: '',
            login_button_text: '',
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            const self = this;
            axios.get('api/dashboard/admin/settings/appearance').then(function (response) {
                self.app_icon = response.data.app_icon;
                self.app_background = response.data.app_background;
                self.background_video_mp4 = response.data.background_video_mp4;
                self.background_video_webm = response.data.background_video_webm;
                self.background_video_url = response.data.background_video_url || '';
                self.login_welcome_title = response.data.login_welcome_title || '';
                self.login_welcome_subtitle = response.data.login_welcome_subtitle || '';
                self.login_button_text = response.data.login_button_text || '';
                self.loading = false;
            }).catch(function () {
                this.$router.push('/dashboard/admin/settings');
            });
        },
        save() {
            const self = this;
            const formData = new FormData();
            self.loading = true;

            if (self.app_icon.file) {
                formData.append('icon', self.app_icon.file);
            }
            if (self.app_background.file) {
                formData.append('background', self.app_background.file);
            }
            if (self.background_video_mp4 && self.background_video_mp4.file) {
                formData.append('background_video_mp4', self.background_video_mp4.file);
            }
            if (self.background_video_webm && self.background_video_webm.file) {
                formData.append('background_video_webm', self.background_video_webm.file);
            }

            formData.append('background_video_url', self.background_video_url);
            formData.append('login_welcome_title', self.login_welcome_title);
            formData.append('login_welcome_subtitle', self.login_welcome_subtitle);
            formData.append('login_button_text', self.login_button_text);

            axios.post('api/dashboard/admin/settings/appearance', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(function (response) {
                self.loading = false;

                if (self.app_icon.file) {
                    self.app_icon.file = null;
                    window.app.icon = response.data.app_icon;
                    document.querySelector("link[rel*='icon']").href = window.app.icon;
                }

                if (self.app_background.file) {
                    self.app_background.file = null;
                    window.app.background = response.data.app_background;
                }

                if (self.background_video_mp4 && self.background_video_mp4.file) {
                    self.background_video_mp4.file = null;
                    window.app.background_video_mp4 = response.data.background_video_mp4;
                }
                if (self.background_video_webm && self.background_video_webm.file) {
                    self.background_video_webm.file = null;
                    window.app.background_video_webm = response.data.background_video_webm;
                }

                window.app.background_video_url = response.data.background_video_url;
                window.app.login_welcome_title = response.data.login_welcome_title;
                window.app.login_welcome_subtitle = response.data.login_welcome_subtitle;
                window.app.login_button_text = response.data.login_button_text;

                self.$store.commit('setSettings', window.app);

                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Settings updated successfully').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
